/* eslint-disable no-restricted-imports */
import { selectIsCollectionReported } from '../../data-layer/collections/selectors';
import { useSelector } from '../../data-layer/useSelector';

export const useIsCollectionReported = (collectionId: string): boolean =>
    useSelector((state) => selectIsCollectionReported(state, collectionId));
